import MobileMenuContextLabelButton from "../MobileMenu/MobileMenuContextLabelButton.jsx";
import Icon from "../../Icon/Icon.jsx";
import ListGroup from "./ListGroup.jsx";
import { navItemShape } from "../PrimaryNav/primaryNavTypes.js";
import { func, object } from "prop-types";
import cx from "classnames";

const propTypes = {
  item: navItemShape.isRequired,
  returnToPreviousScreen: func,
  style: object,
};

const CallToActionMegaMenu = (props) => {
  const { item, returnToPreviousScreen, style, ...otherProps } = props;

  return (
    <div className="call-to-action__dropdown" {...otherProps} style={style}>
      <MobileMenuContextLabelButton
        returnToPreviousScreen={returnToPreviousScreen}
        label={item.title}
      />
      <div className="call-to-action__dropdown-container">
        {/* link list */}
        <div className="call-to-action__link-list-container">
          <ul className="call-to-action__link-list">
            {item.children.map((group, i) => {
              return (
                <li key={i} className="call-to-action__link-list-item">
                  <div className="call-to-action__link-list-label">
                    {group.label}
                  </div>
                  <ListGroup items={group.children} />
                </li>
              );
            })}
          </ul>
        </div>

        {/* call to action */}
        <div className="call-to-action__container">
          <div className="call-to-action__inner-container">
            <a
              href={item.href}
              target={item.target}
              className="link-descriptions__dropdown-list-link"
            >
              {item.callToActionTitle}
              {item.target === "_blank" && (
                <Icon
                  iconName="arrow-right"
                  className="link-descriptions__arrow-icon link-descriptions__arrow-icon--top-right"
                />
              )}
            </a>
            <div
              dangerouslySetInnerHTML={{ __html: item.callToActionDescription }}
              className="link-descriptions__dropdown-list-description"
            ></div>
          </div>
        </div>
      </div>
    </div>
  );
};

CallToActionMegaMenu.propTypes = propTypes;
export default CallToActionMegaMenu;
